import { getRayon, getGorod } from "../../../../utilities";

export const fieldsInterestedPerson = {
  personalDataCaption: {
    key: "personalDataCaption",
    caption: "Личные данные",
    needInWindow: true,
  },
  addressCaption: {
    key: "addressCaption",
    caption: "Адрес",
    needInWindow: true,
  },
  surname: {
    key: "surname",
    value: "Фамилия",
    type: "text",
    disabled: false,
    required: true,
    needInWindow: true,
    lang: "ru",
  },
  surnameEn: {
    key: "surnameEn",
    value: "Surname",
    type: "text",
    disabled: false,
    required: true,
    needInWindow: true,
    lang: "en",
  },
  name: {
    key: "name",
    value: "Имя",
    type: "text",
    disabled: false,
    required: true,
    needInWindow: true,
    lang: "ru",
  },
  nameEn: {
    key: "nameEn",
    value: "Name",
    type: "text",
    disabled: false,
    required: true,
    needInWindow: true,
    lang: "en",
  },
  midname: {
    key: "midname",
    value: "Отчество",
    type: "text",
    disabled: false,
    required: false,
    needInWindow: true,
    lang: "ru",
  },
  docType: {
    key: "docType",
    value: "Документ",
    type: "selectSearch",
    disabled: false,
    isSearchable: false,
    required: true,
    needInWindow: true,
    options: [],
  },
  docSeries: {
    key: "docSeries",
    value: "Серия",
    type: "text",
    defaultValue: undefined,
    disabled: false,
    required: true,
    needInWindow: true,
  },
  docNum: {
    key: "docNum",
    value: "Номер",
    type: "text",
    defaultValue: undefined,
    disabled: false,
    required: true,
    needInWindow: true,
  },
  docDateIssue: {
    key: "docDateIssue",
    value: "Дата выдачи",
    type: "date",
    disabled: false,
    required: true,
    needInWindow: true,
  },
  docDepartment: {
    key: "docDepartment",
    value: "Кем выдан",
    type: "text",
    disabled: false,
    required: true,
    needInWindow: true,
    lang: "ru",
  },
  persNum: {
    key: "persNum",
    value: "Идентификационный номер",
    type: "text",
    disabled: false,
    required: true,
    needInWindow: true,
    maxlength: 15,
  },
  birthDate: {
    key: "birthDate",
    value: "Дата рождения",
    type: "date",
    disabled: false,
    required: true,
    needInWindow: true,
  },
  address: {
    key: "address",
    value: "Адрес",
    type: "text",
    textarea: "textarea",
    required: true,
    needInWindow: true,
    disabled: false,
  },
  phone: {
    key: "phone",
    value: "Телефон",
    type: "text",
    disabled: false,
    required: true,
    needInWindow: true,
  },
  addressEn: {
    key: "addressEn",
    value: "Address",
    type: "text",
    textarea: "textarea",
    disabled: false,
    required: true,
    needInWindow: true,
    lang: "en",
  },
  birthPlace: {
    key: "birthPlace",
    value: "Место рождения",
    type: "text",
    disabled: false,
    required: true,
    needInWindow: true,
    placeholder: "Введите полное наименование страны",
    lang: "ru",
  },
  birthPlaceEn: {
    key: "birthPlaceEn",
    value: "Place of birth",
    type: "text",
    disabled: false,
    required: true,
    needInWindow: true,
    lang: "en",
  },
  residence: {
    key: "residence",
    value: "Гражданство",
    type: "text",
    disabled: false,
    required: true,
    needInWindow: true,
    placeholder: "Введите полное наименование страны",
    lang: "ru",
  },
  residenceEn: {
    key: "residenceEn",
    value: "Residence",
    type: "text",
    disabled: false,
    required: true,
    needInWindow: true,
    lang: "en",
  },
};

export const setupOptionsInterestedPersonByCertificateType = (typeId) => {
  if (Number(typeId) === 1) {
    for (let item in fieldsInterestedPerson) {
      if (
        fieldsInterestedPerson[item].key.includes("En") ||
        fieldsInterestedPerson[item].key === "residence"
      ) {
        fieldsInterestedPerson[item].needInWindow = false;
        fieldsInterestedPerson[item].required = false;
      }
    }
  } else {
    for (let item in fieldsInterestedPerson) {
      if (
        fieldsInterestedPerson[item].key.includes("En") ||
        fieldsInterestedPerson[item].key === "residence"
      ) {
        fieldsInterestedPerson[item].needInWindow = true;
        fieldsInterestedPerson[item].required = true;
      }
    }
  }
  return fieldsInterestedPerson;
};
export async function setOptionsInterestedPerson(id, key) {
  if (id) {
    switch (key) {
      case "oblastId": {
        fieldsInterestedPerson.rayonId.options = await getRayon(id);
        fieldsInterestedPerson.rayonId.disabled = fieldsInterestedPerson.rayonId.options.length
          ? false
          : true;
        fieldsInterestedPerson.gorodId.options = [];
        fieldsInterestedPerson.gorodId.disabled = true;
        return fieldsInterestedPerson;
      }
      case "rayonId": {
        fieldsInterestedPerson.gorodId.options = await getGorod(id);
        fieldsInterestedPerson.gorodId.disabled = fieldsInterestedPerson.gorodId.options.length
          ? false
          : true;
        return fieldsInterestedPerson;
      }
      default:
        return fieldsInterestedPerson;
    }
  }
}

export function setDocOptionsInterestedFromDictionaries(docLib) {
  if (docLib.length > 0) {
    const validLib = docLib.map((item) => {
      return {
        ...item,
        key: "docType",
      };
    });
    if (fieldsInterestedPerson.docType.options.length === 0) {
      fieldsInterestedPerson.docType.options.push(...validLib);
    }
  }
}

export const setupOptionsInterestedPersonForExchange = async () => {
  for (let item in fieldsInterestedPerson) {
    if (fieldsInterestedPerson[item].key !== "phone") {
      fieldsInterestedPerson[item].disabled = true;
    }
  }
  // for (let item in fieldsInterestedPerson) {
  //   if (
  //     fieldsInterestedPerson[item].key.includes("En") ||
  //     fieldsInterestedPerson[item].key === "residence"
  //   ) {
  //     fieldsInterestedPerson[item].needInWindow = true;
  //     fieldsInterestedPerson[item].required = true;
  //   }
  // }
  return fieldsInterestedPerson;
};
